
define('text!common/views/ui/close-button.html',[],function () { return '<button class="email-sub__close js-email-sub--close" data-link-name="hide">\n    <span class="email-sub__hidden">Close</span>\n    <span class="email-sub__close-icon">\n        <%=closeIcon%>\n    </span>\n</button>\n';});

